import color from '@deprecated-ui/_style/color';
import { useLivePriceSingleReceiver } from 'global/Datafeed/UseLivePrice/useLivePriceSingleReceiver';
import { Td } from './styled';

const Change = ({ change, symbol }) => {
  const { livePrice } = useLivePriceSingleReceiver(
    symbol,
    'sector_change',
  );

  let textColor = color.midgray;
  const livePriceChange = livePrice?.change;
  const showLivePrice = typeof livePriceChange !== 'undefined';
  const priceChange = showLivePrice ? livePriceChange : parseInt(change, 10);

  if (priceChange > 0) {
    textColor = color.primary;
  }
  if (priceChange < 0) {
    textColor = color.sunsetOrange;
  }

  return (
    <Td align="right" color={textColor} p="0">
      {!Number.isNaN(priceChange) ? parseFloat(priceChange.toFixed(2)) : 0}
    </Td>
  );
};

export default Change;
